import React, { useEffect, useLayoutEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import BottomButtons from "components/buttons/bottomButtons";
import HeadingComponent from "components/headingComponent";
import {
  addDoc,
  and,
  collection,
  doc,
  getDocs,
  or,
  query,
  Timestamp,
  updateDoc,
  where,
} from "firebase/firestore";
import { dbFirestore } from "helper/config/firebase";
import MaritalKeys from "helper/constant/maritalKeys";
import ErrorMessages from "helper/errorMessages";
import RoutingPaths from "helper/routingPath";
import TableName from "helper/tableName/tableName";
import ToastMessages from "helper/toastMessages";
import ButtonLabels from "helper/constant/buttonLabels";
import CommonHeadings from "helper/constant/headings";
import VisaRefusalKeys from "helper/constant/visaRefusalKeys";
import Dateformat from "helper/constant/timeFormat";
import moment from "moment";
import AsyncSelect from "react-select/async";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";

function AddStudents() {
  const [studentsHeading, setStudentsHeading] = useState(
    CommonHeadings.studentAddHeading
  );
  const [buttonLabel, setButtonLabel] = useState(ButtonLabels.saveLabel);
  const [isSubmitted, setIsSubmitted] = useState(false); // when we submit the form, it will check the error
  const [admissionDate, setAdmissionDate] = useState(null); // only use in the primereact calendar when we select the admission date
  const [rejoinDate, setRejoinDate] = useState(null);
  const [dateOfBirth, setDateOfBirth] = useState(null); // only use in the primereact calendar when we select the admission date
  const [demoDate, setDemoDate] = useState(null); // only use in the primereact calendar when we select the admission date
  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [isInvalidAdmNo, setIsInvalidAdmNo] = useState(false);
  const [studentsID, setStudentsID] = useState();
  const navigate = useNavigate();
  const location = useLocation();
  const dropdownValues = [
    MaritalKeys.single,
    MaritalKeys.married,
    MaritalKeys.divorced,
    MaritalKeys.widowed,
  ]; // in this file , we just define the marital keys\
  const visaRefusalDropdown = [VisaRefusalKeys.key1, VisaRefusalKeys.key2];

  const [students, setstudents] = useState({
    // set input values
    admission_no: "",
    dob: null,
    name: "",
    father_husband_name: "",
    father_husband_no: "",
    selected_marital_status: "",
    address: "",
    contact_no: "",
    reference: "",
    email: "",
    admission_date: null,
    admission_date_timestamp: null,
    demo_date: null,
    demo_date_timestamp: null,
    batch_fee: "",
    rejoin_date: null,
    rejoin_date_timestamp: null,
    batch_fee_num: null,
    selected_visa_refusal: "",
    refusal_reason: "",
    selected_course_id: null,
    batch_firebase_id: null,
    selected_payment_duration_id: null,
  });

  const [errors, setErrors] = useState({
    admission_no: "",
    dob: "",
    name: "",
    father_husband_name: "",
    father_husband_no: "",
    contact_no: "",
    admission_date: "",
    batch_fee: "",
    selected_course_id: "",
    batch_firebase_id: "",
    selected_payment_duration_id: "",
  });

  // MARK: Use Effect Method
  useEffect(() => {
    setEditStudentsUI();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  //  Use Layout Method
  useLayoutEffect(() => {
    document.title = location.state
      ? CommonHeadings.studentEditHeading
      : CommonHeadings.studentAddHeading;
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  //   when we enter any value that's set in the setDemoStudents() and chenge the input afer submitting like blank all the inputs
  const inputChange = (e) => {

    var { name, value } = e.target;

    if (name === "dob") {
      value = moment(value).format(Dateformat.YYYYMMDD);
    }

    if (name === "admission_date") {
      value = moment(value).format(Dateformat.YYYYMMDD);
    }

    if (name === "demo_date") {
      value = moment(value).format(Dateformat.YYYYMMDD);
    }

    setstudents({
      ...students,
      [name]: value,
    });

    if (name === "admission_no") {
      checkAdmissionNumber(value).then((result) => {
        setIsInvalidAdmNo(result);
      });
    }
  };

  //   this function is only used for the dropdown input where users can select the category for demo classes by selecting into the dropdown
  const inputDropMaritalChange = (e) => {
    const { name, value } = e.target;

    setstudents({
      ...students,
      [name]: value,
    });
  };

  const inputDropVisaRefusal = (e) => {
    const { name, value } = e.target;

    setstudents({
      ...students,
      [name]: value,
    });
  };

  const courseSelect = (e) => {
    const name = "selected_course_id";

    setstudents({
      ...students,
      [name]: e,
    });

    const newErrors = validateForm(students);
    setErrors(newErrors);
  };

  const paymentSelect = (e) => {
    const name = "selected_payment_duration_id";

    setstudents({
      ...students,
      [name]: e,
    });

    const newErrors = validateForm(students);
    setErrors(newErrors);
  };

  const batchSelect = (e) => {
    const name = "batch_firebase_id";

    setstudents({
      ...students,
      [name]: e,
    });

    const newErrors = validateForm(students);
    setErrors(newErrors);
  };

  const validateForm = (data) => {
    const errors = {};

    if (!data.name) {
      errors.name = ErrorMessages.name;
    }

    if (!data.admission_no) {
      errors.admission_no = ErrorMessages.admissionNumber;
    }

    if (!data.dob) {
      errors.dob = ErrorMessages.dateOfBirth;
    }
    if (!data.father_husband_name) {
      errors.father_husband_name = ErrorMessages.fatherHusbandName;
    }
    if (!data.contact_no) {
      errors.contact_no = ErrorMessages.phone;
    } else if (!/^\d*$/.test(data.contact_no)) {
      errors.contact_no = ErrorMessages.phoneNumber;
    }
    if (!data.father_husband_no) {
      errors.father_husband_no = ErrorMessages.phone;
    } else if (!/^\d*$/.test(data.father_husband_no)) {
      errors.father_husband_no = ErrorMessages.phoneNumber;
    }
    if (!data.admission_date) {
      errors.admission_date = ErrorMessages.admissionDate;
    }
    if (!data.selected_course_id) {
      errors.selected_course_id = ErrorMessages.courses;
    }
    if (!data.batch_firebase_id) {
      errors.batch_firebase_id = ErrorMessages.batches;
    }
    if (!data.selected_payment_duration_id) {
      errors.selected_payment_duration_id = ErrorMessages.paymentDuration;
    }
    if (!data.batch_fee) {
      errors.batch_fee = ErrorMessages.monthlyPayment;
    } else if (!/^\d*$/.test(data.batch_fee)) {
      errors.batch_fee = ErrorMessages.paymentNumeric;
    }
    if (data.selected_visa_refusal === VisaRefusalKeys.key1) {
      if (!data.refusal_reason) {
        errors.refusal_reason = ErrorMessages.refusalReason;
      }
    }

    return errors;
  };

  async function payingFeesConfirmation(isSaveNext) {
    Swal.fire({
      title: "Would you like to pay fee?",
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonColor: "var(--primary-color)",
      cancelButtonColor: "var(--cancel-button-list)",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      icon: "warning",
    }).then((result) => {
      if (result.value) {
        navigate(RoutingPaths.feesData);
      } else {
        isSaveNext ? navigate(RoutingPaths.addStudents) : navigate(RoutingPaths.studentsList);
      }
    });
  }

  // MARK: tap on button
  // this function is working when we submit the form by clicking on save button
  const tapOnSave = async () => {
    const newErrors = validateForm(students);
    setErrors(newErrors);
    setIsSubmitted(true);
    if (Object.keys(newErrors).length === 0) {
      if (isInvalidAdmNo) {
        toast.error(ErrorMessages.admissionNumberTaken);
      } else {
        setLoading1(true);
        if (location.state) {
          updateStudentsApi();
        } else {
          writeStudentsApi()
        }
      }
    }

  };

  // this function is working when we submit the form by clicking on save andnext button
  const tapOnSaveNext = () => {
    const newErrors = validateForm(students);
    setErrors(newErrors);
    setIsSubmitted(true);
    if (Object.keys(newErrors).length === 0) {
      if (isInvalidAdmNo) {
        toast.error(ErrorMessages.admissionNumberTaken);
      } else {
        setLoading2(true);
        writeStudentsApi(true);
      }
    }
  };

  // MARK: reset values function
  function ResetValues() {
    setstudents({
      admission_no: "",
      dob: "",
      name: "",
      father_husband_name: "",
      father_husband_no: "",
      selected_marital_status: "",
      address: "",
      contact_no: "",
      reference: "",
      email: "",
      admission_date: "",
      admission_date_timestamp: "",
      demo_date: "",
      demo_date_timestamp: "",
      rejoin_date: "",
      rejoin_date_timestamp: "",
      selected_course_id: "",
      batch_firebase_id: "",
      selected_payment_duration_id: "",
      batch_fee: "",
      batch_fee_num: "",
      selected_visa_refusal: "",
      refusal_reason: "",
    });
  }

  // MARK: API
  //fetch batches API
  async function fetchBatchesApi() {
    let q = query(collection(dbFirestore, TableName.batches));

    const querySnapshot = await getDocs(q);
    const batchArray = querySnapshot.docs.map((docs) => ({
      ...docs.data(),
    }));

    var batchObject = batchArray.find(function (batch) {
      return (batch.firebase_id = location.state.batch_firebase_id);
    });
    return batchObject;
  }

  //fetch course API
  async function fetchCoursesApi() {
    let q = query(collection(dbFirestore, TableName.courses));

    const querySnapshot = await getDocs(q);
    const courseArray = querySnapshot.docs.map((docs) => ({
      ...docs.data(),
    }));

    var courseObject = courseArray.find(function (course) {
      return course.id === location.state.selected_course_id;
    });

    return courseObject;
  }

  // fetch payemnt API
  async function fetchPaymentApi() {
    let paymentQ = query(collection(dbFirestore, TableName.paymenyDuration));

    const querySnapshotPayment = await getDocs(paymentQ);
    const paymentArray = querySnapshotPayment.docs.map((docs) => ({
      ...docs.data(),
    }));

    var paymentObject = paymentArray.find(
      (payment) => location.state.selected_payment_duration_id === payment.id
    );

    return paymentObject;
  }

  // fetch student API
  async function checkAdmissionNumber(value) {
    let q = query(
      collection(dbFirestore, TableName.students),
      where("admission_no", "==", value)
    );

    const querySnapshotDocs = await getDocs(q);

    return querySnapshotDocs.docs.length > 0 ? true : false;
  }

  //  write API
  async function writeStudentsApi(isSaveNext) {
    const writePayload = payload();
    writePayload.batch_firebase_id = students.batch_firebase_id?.firebase_id;
    writePayload.selected_course_id = students.selected_course_id.id;
    writePayload.selected_payment_duration_id =
      students.selected_payment_duration_id.id;
    const status = "active";

    try {
      await addDoc(collection(dbFirestore, TableName.students), {
        ...writePayload,
        status: status,
      });

      if (isSaveNext) {
        toast.success(ToastMessages.demoStudentsAdd);
        setTimeout(() => {
          setLoading2(false);
          payingFeesConfirmation(true);
          ResetValues();
        }, 600);
      } else {
        toast.success(ToastMessages.demoStudentsAdd);
        setTimeout(() => {
          setLoading1(false);
          payingFeesConfirmation();
        }, 600);
      }
    } catch (error) {
      setLoading1(false); // hide
      setLoading2(false);
      const errorMessage = error.message;
      toast.error(errorMessage);
    }
  }

  //  update API
  async function updateStudentsApi() {
    const updatedPayload = payload();
    updatedPayload.created_at = location.state.created_at;
    updatedPayload.updated_at = Timestamp.fromDate(new Date()).toMillis();
    updatedPayload.batch_firebase_id = students.batch_firebase_id?.firebase_id;
    updatedPayload.selected_course_id = students.selected_course_id.id;
    updatedPayload.selected_payment_duration_id =
      students.selected_payment_duration_id.id;
    if (updatedPayload.rejoin_date) {
      updatedPayload.rejoin_date = moment(updatedPayload.rejoin_date).format(Dateformat.YYYYMMDD);
      updatedPayload.rejoin_date_timestamp = Timestamp.fromDate(new Date(updatedPayload.rejoin_date)).toMillis();
    } else {
      updatedPayload.rejoin_date = null;
      updatedPayload.rejoin_date_timestamp = null;
    }


    try {
      await updateDoc(doc(dbFirestore, TableName.students, studentsID), {
        ...updatedPayload,
      });
      toast.success(ToastMessages.demoStudentsUpdated);
      setTimeout(() => {
        setLoading1(false);
        navigate(RoutingPaths.studentsList);
      }, 600);
    } catch (error) {
      const errorMessage = error.message;
      toast.error(errorMessage);
    }
  }

  // MARK: string to date
  const stringToDate = (props) => {
    return moment(props, Dateformat.YYYYMMDD).toDate();
  };

  // MARK: edit data function
  async function setEditStudentsUI() {
    if (!location.state) return;
    const batchObject = await fetchBatchesApi();
    const paymentObject = await fetchPaymentApi();
    const courseObject = await fetchCoursesApi();
    const demoDate = stringToDate(location.state.demo_date);
    setDemoDate(demoDate);

    const admissionDate = stringToDate(location.state.admission_date);
    setAdmissionDate(admissionDate);

    const birthDate = stringToDate(location.state.dob);
    setDateOfBirth(birthDate);
    setstudents((prevState) => ({
      ...prevState,
      admission_no: location.state.admission_no,
      dob: location.state.dob,
      name: location.state.name,
      father_husband_name: location.state.father_husband_name,
      father_husband_no: location.state.father_husband_no,
      selected_marital_status: location.state.selected_marital_status,
      address: location.state.address,
      contact_no: location.state.contact_no,
      reference: location.state.reference,
      email: location.state.email,
      admission_date: location.state.admission_date,
      rejoin_date: stringToDate(location.state.rejoin_date),
      demo_date: location.state.demo_date,
      selected_course_id: courseObject,
      batch_firebase_id: batchObject,
      selected_payment_duration_id: paymentObject,
      batch_fee: location.state.batch_fee,
      selected_visa_refusal: location.state.selected_visa_refusal,
      refusal_reason: location.state.refusal_reason,
      status: location.state.status
    }));
    setRejoinDate();
    // setDateInput(location.state ? true : false)
    setStudentsHeading(CommonHeadings.studentEditHeading);
    setButtonLabel(ButtonLabels.updateLabel);
    setStudentsID(location.state.id);
  }

  // MARK: payload function
  function payload() {
    const createdAt = Timestamp.fromDate(new Date()).toMillis();

    const object = {
      ...students,
      created_at: createdAt,
      updated_at: null,
    };

    object.batch_fee_num = Number(students.batch_fee);
    object.demo_date_timestamp = Timestamp.fromDate(new Date(object.demo_date)).toMillis();
    object.admission_date_timestamp = Timestamp.fromDate(new Date(object.admission_date)).toMillis();
    object.name = students.name.toLowerCase();
    object.email = students.email.toLowerCase();
    object.address = students.address.toLowerCase();
    object.father_husband_name = students.father_husband_name.toLowerCase();

    return object;
  }

  // MARK: course list fetch from the firebase
  const courseList = async (searchText) => {
    const searchName = searchText.toLowerCase()

    let q = query(
      collection(dbFirestore, TableName.courses),
      or(
        // query as-is:
        and(
          where("name", ">=", searchName),
          where("name", "<=", searchName + "\uf8ff")
        ),
        and(
          where(
            "name",
            ">=",
            searchName.charAt(0).toUpperCase() + searchName.slice(1)
          ),
          where(
            "name",
            "<=",
            searchName.charAt(0).toUpperCase() + searchName.slice(1) + "\uf8ff"
          )
        )
      )
    );
    const querySnapshot = await getDocs(q);
    const s = querySnapshot.docs.map((docs) => ({
      ...docs.data(),
      id: docs.data().id,
      name: docs.data().name,
    }));

    return s;
  };

  //course name which show in the dropdown
  function courseName(e) {
    return e["name"];
  }

  // MARK: payment list fetch from the firebase
  const paymentList = async (searchText) => {
    const searchName = searchText.toLowerCase()

    let q = query(
      collection(dbFirestore, TableName.paymenyDuration),
      or(
        // query as-is:
        and(
          where("name", ">=", searchName),
          where("name", "<=", searchName + "\uf8ff")
        ),
        and(
          where(
            "name",
            ">=",
            searchName.charAt(0).toUpperCase() + searchName.slice(1)
          ),
          where(
            "name",
            "<=",
            searchName.charAt(0).toUpperCase() + searchName.slice(1) + "\uf8ff"
          )
        )
      )
    );
    const querySnapshot = await getDocs(q);

    const s = querySnapshot.docs.map((docs) => ({
      ...docs.data(),
      id: docs.data().id,
    }));
    return s;
  };

  //  payment name which show in the dropdown
  function paymentName(e) {
    return e["name"];
  }

  // MARK: batch list fetch from the firebase
  const batchList = async (searchText) => {
    const searchName = searchText.toLowerCase()

    let q = query(
      collection(dbFirestore, TableName.batches),
      or(
        // query as-is:
        and(
          where("batch_name", ">=", searchName),
          where("batch_name", "<=", searchName + "\uf8ff")
        ),
        and(
          where(
            "batch_name",
            ">=",
            searchName.charAt(0).toUpperCase() + searchName.slice(1)
          ),
          where(
            "batch_name",
            "<=",
            searchName.charAt(0).toUpperCase() + searchName.slice(1) + "\uf8ff"
          )
        )
      )
    );
    const querySnapshot = await getDocs(q);
    const array = querySnapshot.docs.map((docs) => ({
      ...docs.data(),
      firebase_id: docs.id,
    }));
    return array;
  };

  //  batch name which show in the dropdown
  function batchName(e) {
    return e["batch_name"];
  }

  return (
    <div className="modules__main__div">
      <div className="col-12">
        <div className="card modules__card">
          <h2 className="mb-4 text-center fw-bolder">{studentsHeading}</h2>
          {/* p-fluid is the primereact class */}
          <div className="p-fluid">
            <div className="row modules__row">
              <HeadingComponent
                headingName="Admission Info"
                classname="mt-4 mb-1"
              />

              <div className="col-12 col-md-6">
                <label htmlFor="admission_no" className="input__valid">
                  Admission Number
                </label>
                <InputText
                  name="admission_no"
                  value={students.admission_no}
                  onChange={inputChange}
                  id="admission_no"
                  type="text"
                  placeholder="Enter your admission number"
                />
                {isSubmitted && students.admission_no === '' && <small id="admission_no" className="p-error">
                  {errors.admission_no}
                </small>}
                {(
                  <small id="admission_no" className="p-error">
                    {isInvalidAdmNo ? ErrorMessages.admissionNumberTaken : ''}
                  </small>
                )}
              </div>

              <div className="col-12 col-md-6">
                <label htmlFor="admission_date" className="input__valid">
                  Admission Date
                </label>
                <Calendar
                  name="admission_date"
                  value={admissionDate}
                  onChange={inputChange}
                  showIcon
                  showButtonBar
                  placeholder="dd/mm/yyyy"
                  dateFormat="dd/mm/yy"
                />
                {isSubmitted && (
                  <small id="admission_date" className="p-error">
                    {errors.admission_date}
                  </small>
                )}

              </div>

              {location.state && <div className="col-12 col-md-6">
                <label htmlFor="rejoin_date">
                  Re-join Date
                </label>
                <Calendar
                  name="rejoin_date"
                  value={students.rejoin_date}
                  onChange={inputChange}
                  showIcon
                  showButtonBar
                  placeholder="dd/mm/yyyy"
                  dateFormat="dd/mm/yy"
                />
              </div>}
            </div>

            <div className="row modules__row">
              <HeadingComponent
                headingName="Personal Info"
                classname="mt-4 mb-1"
              />

              <div className="col-12 col-md-6">
                <label htmlFor="name" className="input__valid">
                  Name
                </label>
                <InputText
                  name="name"
                  value={students.name}
                  onChange={inputChange}
                  id="name"
                  type="text"
                  placeholder="Enter your name"
                />
                {isSubmitted && students.admission_no === '' && (
                  <small id="name" className="p-error">
                    {errors.name}{" "}
                  </small>
                )}
              </div>

              <div className="col-12 col-md-6">
                <label htmlFor="dob" className="input__valid">
                  Date of birth
                </label>
                <Calendar
                  name="dob"
                  value={dateOfBirth}
                  onChange={inputChange}
                  showIcon
                  showButtonBar
                  placeholder="dd/mm/yyyy"
                  dateFormat="dd/mm/yy"
                />
                {isSubmitted && (
                  <small id="dob" className="p-error">
                    {errors.dob}{" "}
                  </small>
                )}
              </div>

              <div className="col-12 col-md-6">
                <label htmlFor="email">Email</label>
                <InputText
                  name="email"
                  value={students.email}
                  onChange={inputChange}
                  id="email"
                  type="text"
                  placeholder="Enter your email"
                />
              </div>

              <div className="col-12 col-md-6">
                <label htmlFor="contact_no" className="input__valid">
                  Contact Number
                </label>
                <InputText
                  name="contact_no"
                  value={students.contact_no}
                  onChange={inputChange}
                  id="contact_no"
                  type="tel"
                  maxLength={10}
                  placeholder="Enter your contact number"
                />
                {isSubmitted && (
                  <small id="contact_no" className="p-error">
                    {errors.contact_no}{" "}
                  </small>
                )}
              </div>

              <div className="col-12 col-md-6">
                <label htmlFor="father_husband_name" className="input__valid">
                  Father/Husband Name
                </label>
                <InputText
                  name="father_husband_name"
                  value={students.father_husband_name}
                  onChange={inputChange}
                  id="father_husband_name"
                  type="text"
                  placeholder="Enter your father/husband name"
                />
                {isSubmitted && (
                  <small id="father_husband_name" className="p-error">
                    {errors.father_husband_name}{" "}
                  </small>
                )}
              </div>

              <div className="col-12 col-md-6">
                <label htmlFor="father_husband_no" className="input__valid">
                  Father/Husband Contact No.
                </label>
                <InputText
                  name="father_husband_no"
                  value={students.father_husband_no}
                  onChange={inputChange}
                  id="father_husband_no"
                  type="text"
                  maxLength={10}
                  placeholder="Enter your father/husband number"
                />
                {isSubmitted && (
                  <small id="father_husband_no" className="p-error">
                    {errors.father_husband_no}{" "}
                  </small>
                )}
              </div>

              <div className="col-12 col-md-6">
                <label htmlFor="address">Address</label>
                <InputTextarea
                  name="address"
                  value={students.address}
                  onChange={inputChange}
                  id="address"
                  placeholder="Enter your address"
                  rows={3}
                  cols={30}
                />
              </div>

              <div className="col-12 col-md-6">
                <label htmlFor="selected_marital_status">Marital Status</label>
                <Dropdown
                  name="selected_marital_status"
                  value={students.selected_marital_status}
                  onChange={inputDropMaritalChange}
                  options={dropdownValues}
                  optionLabel="name"
                  placeholder="Select your marriage status"
                />
              </div>
            </div>

            <div className="row modules__row">
              <HeadingComponent
                headingName="Course Info"
                classname="mt-4 mb-1"
              />

              <div className="col-12 col-md-6">
                <label htmlFor="selected_course_id" className="input__valid">
                  Course Selection
                </label>
                <AsyncSelect
                  classNamePrefix="course__dropdown"
                  maxMenuHeight={170}
                  isClearable
                  cacheOptions
                  loadOptions={courseList}
                  value={students.selected_course_id}
                  defaultOptions
                  getOptionLabel={(e) => courseName(e)}
                  getOptionValue={(e) => e}
                  onChange={courseSelect}
                />
                {isSubmitted && (
                  <small id="selected_course_id" className="p-error">
                    {errors.selected_course_id}{" "}
                  </small>
                )}
              </div>

              <div className="col-12 col-md-6">
                <label htmlFor="demo_date">Demo Date (Optional)</label>
                <Calendar
                  name="demo_date"
                  value={demoDate}
                  onChange={inputChange}
                  showIcon
                  showButtonBar
                  placeholder="dd/mm/yyyy"
                  dateFormat="dd/mm/yy"
                />
              </div>

              <div className="col-12 col-md-6">
                <label htmlFor="batch_firebase_id" className="input__valid">
                  Batch Selection
                </label>
                <AsyncSelect
                  classNamePrefix="batch__dropdown"
                  maxMenuHeight={170}
                  isClearable
                  cacheOptions
                  loadOptions={batchList}
                  value={students.batch_firebase_id}
                  defaultOptions
                  getOptionLabel={(e) => batchName(e)}
                  getOptionValue={(e) => e["name"]}
                  onChange={batchSelect}
                />
                {isSubmitted && (
                  <small id="batch_firebase_id" className="p-error">
                    {errors.batch_firebase_id}{" "}
                  </small>
                )}
              </div>
            </div>

            <div className="row modules__row">
              <HeadingComponent
                headingName="Payment Info"
                classname="mt-4 mb-1"
              />

              <div className="col-12 col-md-6">
                <label
                  htmlFor="selected_payment_duration_id"
                  className="input__valid"
                >
                  Payment Duration
                </label>
                <AsyncSelect
                  maxMenuHeight={170}
                  isClearable
                  cacheOptions
                  loadOptions={paymentList}
                  value={students.selected_payment_duration_id}
                  defaultOptions
                  getOptionLabel={(e) => paymentName(e)}
                  getOptionValue={(e) => e["id"]}
                  onChange={paymentSelect}
                />
                {isSubmitted && (
                  <small id="selected_payment_duration_id" className="p-error">
                    {errors.selected_payment_duration_id}{" "}
                  </small>
                )}
              </div>

              <div className="col-12 col-md-6">
                <label htmlFor="batch_fee" className="input__valid">
                  Batch Fee Per Month
                </label>
                <InputText
                  name="batch_fee"
                  value={students.batch_fee}
                  onChange={inputChange}
                  id="batch_fee"
                  type="tel"
                  placeholder="Enter per month batch fee"
                />
                {isSubmitted && (
                  <small id="batch_fee" className="p-error">
                    {errors.batch_fee}{" "}
                  </small>
                )}
              </div>
            </div>

            <div className="row modules__row">
              <HeadingComponent
                headingName="Other Info"
                classname="mt-4 mb-1"
              />

              <div className="col-12 col-md-6">
                <label htmlFor="reference">Reference (Optional)</label>
                <InputText
                  name="reference"
                  value={students.reference}
                  onChange={inputChange}
                  id="reference"
                  type="text"
                  placeholder="Enter your reference"
                />
              </div>

              <div className="col-12 col-md-6">
                <label htmlFor="selected_visa_refusal">
                  Previous Visa Refusal
                </label>
                <Dropdown
                  name="selected_visa_refusal"
                  value={students.selected_visa_refusal}
                  onChange={inputDropVisaRefusal}
                  options={visaRefusalDropdown}
                  optionLabel="name"
                  placeholder="Select refusal option "
                />
              </div>

              {students.selected_visa_refusal === VisaRefusalKeys.key1 && (
                <div className="col-12 col-md-6">
                  <label htmlFor="refusal_reason">Description</label>
                  <InputTextarea
                    name="refusal_reason"
                    value={students.refusal_reason}
                    onChange={inputChange}
                    id="refusal_reason"
                    placeholder="Enter refusal reason"
                    rows={3}
                    cols={30}
                  />
                </div>
              )}
            </div>
          </div>

          <BottomButtons
            label={buttonLabel}
            loading1={loading1}
            save={tapOnSave}
            saveNext={tapOnSaveNext}
            loading2={loading2}
          />
          <ToastContainer />
        </div>
      </div>
    </div>
  );
}

export default AddStudents;